<template lang="html">
  <div class="kid">
    <span v-if="avatar">
      <img :src="avatar" :alt="name" />
    </span>

    <span v-else>
      <img src="../../assets/placeholder.svg" :alt="name" />
    </span>

    <div class="info">
      <h3>{{ name }}</h3>
      <p>Status of kid</p>
      <router-link :to="{ name: 'KidDetail', params: { id: id } }">View Profile</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Preview",
    props: ["id", "name", "avatar"],
  };
</script>

<style scoped lang="css">
  .kid {
    display: inline-block;
    margin: 20px;
    padding: 10px;
    border: 2px solid #8c5925;
    width: 500px;
  }

  img {
    width: 150px;
    border: 1px solid #b2773c;
  }

  .info {
    display: inline-block;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Kids/Preview.vue